import { breakpoints, getShadowStyle, pxToRems, } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
const drawerTransitionTiming = '400ms';
const drawerTransitionEasing = 'cubic-bezier(0.4, 0, 0.2, 1)';
const overlayTransitionTiming = '400ms';
export const DrawerContentStyled = styled.div `
  position: fixed;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
  transition: transform ${drawerTransitionTiming} ${drawerTransitionEasing};

  ${({ placement, horizontalMaxWidth }) => (placement === 'left' || placement === 'right') &&
    css `
      width: 95vw;
      max-width: ${pxToRems(480)};

      @media (min-width: ${breakpoints[0]}px) {
        max-width: ${horizontalMaxWidth || pxToRems(600)};
      }
    `}
  ${({ placement }) => placement === 'left' &&
    css `
      left: 0;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      transform: translateX(-100%);
    `}
    ${({ placement }) => placement === 'right' &&
    css `
      right: 0;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      transform: translateX(100%);
    `}
    ${({ placement }) => ['bottom', 'bottom-content-fit'].includes(placement) &&
    css `
      top: auto;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100vw;
      max-width: 100%;
      max-height: 90vh;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      transform: translateY(100%);
      align-items: center;
    `};
`;
export const DrawerContentWrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: ${({ horizontalMaxWidth }) => horizontalMaxWidth ? '100%' : pxToRems(1200)};
  overflow-y: auto;
  ${(p) => p.placement !== 'bottom-content-fit' &&
    css `
      height: 100vh;
    `}
  ${(p) => p.placement === 'bottom-content-fit' &&
    css `
      width: 100%;
    `}
`;
export const DrawerHeaderStyled = styled.div `
  position: relative;
  width: 100%;
  max-width: ${({ horizontalMaxWidth }) => horizontalMaxWidth ? '100%' : pxToRems(1200)};
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: ${pxToRems(24)};
  padding: ${pxToRems(16)};
  padding-left: ${pxToRems(24)};

  &::after {
    content: '';
    position: relative;
    z-index: 1;
    width: 100%;
    height: 0.5rem;
    position: absolute;
    bottom: -0.5rem;
    padding-bottom: 0.5rem;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;
export const DrawerOverlayStyled = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity ${overlayTransitionTiming} ease-in-out;
  display: block;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.ColorBlackOpacity60};
`;
export const DrawerStyled = styled.div `
  display: block;
  position: relative;

  // Class is added via the CSSTransition wrapper component.
  &.drawer-enter-active,
  &.drawer-enter-done {
    ${DrawerContentStyled} {
      transform: translateX(0);
    }

    ${DrawerOverlayStyled} {
      opacity: 1;
      visibility: visible;
    }
  }
`;
export const DrawerInlineStyled = styled.div `
  ${({ isOpen }) => isOpen &&
    css `
      ${DrawerContentStyled} {
        transform: translateX(0);
      }

      ${DrawerOverlayStyled} {
        opacity: 1;
        visibility: visible;
      }
    `}
`;
export const DrawerBodyStyled = styled.div `
  flex: 1;
  padding: ${({ hasPadding }) => hasPadding
    ? `${pxToRems(12)} ${pxToRems(24)} ${pxToRems(24)} ${pxToRems(24)}`
    : 0};
  @media (min-width: ${breakpoints[1]}px) {
    padding: ${({ hasPadding }) => hasPadding ? `0 ${pxToRems(32)} ${pxToRems(32)} ${pxToRems(32)}` : 0};
  }
`;
export const DrawerFooterStyled = styled.div `
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${pxToRems(16)};
  background: ${({ theme }) => theme.ColorWhiteOpacity100};
  ${({ theme }) => `box-shadow: ${getShadowStyle({ theme, depth: -3 })};`}
`;
//# sourceMappingURL=drawer.styles.js.map